import useProtoMethod from "./useProtoMethod";

import {
  CreateVideoRoomRequest,
  CreateVideoRoomResponse,
  JoinVideoRoomRequest,
  JoinVideoRoomResponse,
  UpdateVideoRoomRequest,
  UpdateVideoRoomResponse,
  EndVideoRoomRequest,
  EndVideoRoomResponse,
  GetVideoTranscriptionsRequest,
  GetVideoTranscriptionsResponse,
  SendVideoInvitationRequest,
  SendVideoInvitationResponse,
} from "../protogen/video_service_pb";

const useCreateVideoRoom = (
  callback?: (r: CreateVideoRoomResponse) => void,
) => {
  return useProtoMethod<CreateVideoRoomRequest, CreateVideoRoomResponse>(
    "CreateVideoRoom",
    CreateVideoRoomResponse,
    { callback },
  );
};

const useJoinVideoRoom = (callback?: (r: JoinVideoRoomResponse) => void) => {
  return useProtoMethod<JoinVideoRoomRequest, JoinVideoRoomResponse>(
    "JoinVideoRoom",
    JoinVideoRoomResponse,
    { callback },
  );
};

const useJoinPublicVideoRoom = (
  callback?: (r: JoinVideoRoomResponse) => void,
) => {
  return useProtoMethod<JoinVideoRoomRequest, JoinVideoRoomResponse>(
    "JoinPublicVideoRoom",
    JoinVideoRoomResponse,
    { callback },
  );
};

const useUpdateVideoRoom = (
  callback?: (r: UpdateVideoRoomResponse) => void,
) => {
  return useProtoMethod<UpdateVideoRoomRequest, UpdateVideoRoomResponse>(
    "UpdateVideoRoom",
    UpdateVideoRoomResponse,
    { callback },
  );
};

const useEndVideoRoom = (callback?: (r: EndVideoRoomResponse) => void) => {
  return useProtoMethod<EndVideoRoomRequest, EndVideoRoomResponse>(
    "EndVideoRoom",
    EndVideoRoomResponse,
    { callback },
  );
};

const useGetVideoTranscriptions = (
  callback?: (r: GetVideoTranscriptionsResponse) => void,
) => {
  return useProtoMethod<
    GetVideoTranscriptionsRequest,
    GetVideoTranscriptionsResponse
  >("GetVideoTranscriptions", GetVideoTranscriptionsResponse, { callback });
};

const useSendVideoInvitation = (
  callback?: (r: SendVideoInvitationResponse) => void,
) => {
  return useProtoMethod<
    SendVideoInvitationRequest,
    SendVideoInvitationResponse
  >("SendVideoInvitation", SendVideoInvitationResponse, { callback });
};

export {
  useCreateVideoRoom,
  useJoinVideoRoom,
  useJoinPublicVideoRoom,
  useUpdateVideoRoom,
  useEndVideoRoom,
  useGetVideoTranscriptions,
  useSendVideoInvitation,
};
